import * as React from 'react';

import { GetAssetResponse, GetGlobalHistoryResponse } from '@blockworks/platform/api/research';
import { AssetTab, PostType } from '@blockworks/platform/api/strapi';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import PricePageLayout from '@/components/pages/price/layout/price-page-layout';
import { ArticleType } from '@/types/article-type';
import { Category } from '@/utils/functions/wordpress/fetch-categories';
import useAnalyticsTrack from '@/utils/hooks/use-analytics-track';

export interface PricePageControllerProps {
    asset: GetAssetResponse['data'];
    recentArticles: PostType[];
    globalMarketHistory: GetGlobalHistoryResponse['data'];
    categories: Category[];
    readMoreArticles: ArticleType[];
    about: AssetTab | null;
    summary: AssetTab | null;
}

const PricePageController = ({
    asset,
    recentArticles,
    globalMarketHistory,
    categories,
    readMoreArticles,
    about,
    summary,
}: PricePageControllerProps) => {
    // Analytics
    useAnalyticsTrack(
        'Price.View',
        asset
            ? {
                  title: asset.title,
                  code: asset.code,
                  slug: asset.slug,
                  category: asset.category,
              }
            : null,
    );

    if (!asset) {
        // return empty component in case asset is not defined
        return null;
    }

    return (
        <PricePageLayout
            asset={asset}
            recentArticles={recentArticles}
            globalMarketHistory={globalMarketHistory}
            categories={categories}
            readMoreArticles={readMoreArticles}
            summary={summary}
            about={about}
        />
    );
};

export default withExceptionCatcher(PricePageController);
